import { SchemaModelType } from '@smx-ui-model/types';

import schema from '../../schema-generated.json';
import { getTagFilteredListQuery } from '../graphql/query/get-tag-filtered-list-query';
import { TagModelSchemaType, TagModelType } from './types';

export const tagCoreModel: TagModelSchemaType = {
    label: 'Tag',
    name: 'tag',
    queryList: getTagFilteredListQuery,
    schema: schema.Tag as unknown as SchemaModelType<TagModelType>,
    searchFilterField: 'tag',
};
